const certificatesData = [
  {
    title: "Learn C++ by CodeChef",
    subject: "Programming Language CPP",
    link: "https://www.codechef.com/certificates/verify",
    id: "ba6aba9",
    username: "subhadipdas452",
  },
  {
    title: "C++ for problem solving - 1",
    subject: "Programming Language CPP",
    link: "https://www.codechef.com/certificates/verify",
    id: "678d111",
    username: "subhadipdas452",
  },
  {
    title: "C++ for problem solving - 2",
    subject: "Programming Language CPP",
    link: "https://www.codechef.com/certificates/verify",
    id: "0cd1927",
    username: "subhadipdas452",
  },
  {
    title: "Communication in the 21st Century Workplace",
    subject: "Soft Skill",
    link: "https://coursera.org/share/05bda90e4f2b9d19a5e805ebc1a422af",
  },
  {
    title: "A Life of Happiness and Fulfillment",
    subject: "Soft Skill",
    link: "https://coursera.org/share/cc98c82578c96dcdbb3b58cca3c4c722",
  },
  {
    title: "Communication theory: bridging academia and practice",
    subject: "Soft Skill",
    link: "https://coursera.org/share/0bad7f5ed736c9c43919661f8e5dfbd3",
  },
];

export default certificatesData;
